module.exports = __webpack_public_path__ + "img/logo-vert.cd7f86dd.svg";